import { inject, Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { Uuid } from '../../../../../../graphql';
import { GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY } from '../../../../../graphql.module';
import { AddPlanMeasurement, AddPlanMeasurementVariables } from './api/add-plan-measurement.generated';
import { AutoMeasure, AutoMeasureVariables } from './api/auto-measure.generated';
import { BulkUpsertEstimateMeasurements, BulkUpsertEstimateMeasurementsVariables } from './api/bulk-upsert-estimate-measurement.generated';

@Injectable({
    providedIn: 'root',
})
export class AutoMeasureApiService {
    readonly #apollo = inject(Apollo);

    get #gql() {
        return this.#apollo.use(GLOBAL_GRAPHQLGATEWAY_NAME_NO_OVERLAY);
    }

    autoMeasurePlan(autoMeasureInput: AutoMeasureVariables['input']) {
        return this.#gql.mutate({
            mutation: AutoMeasure,
            variables: {
                input: autoMeasureInput,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    addMeasurementforPlan(planInput: AddPlanMeasurementVariables['model']) {
        return this.#gql.mutate({
            mutation: AddPlanMeasurement,
            variables: {
                model: planInput,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }

    bulkUpsertEstimateMeasurements(estimateId: Uuid, measurements: BulkUpsertEstimateMeasurementsVariables['models']) {
        return this.#gql.mutate({
            mutation: BulkUpsertEstimateMeasurements,
            variables: {
                estimateId: estimateId,
                models: measurements,
            },
            fetchPolicy: 'no-cache',
            errorPolicy: 'all',
        });
    }
}
